// Partnership closure report — professional PDF-ready HTML
import api from "./api";
import { fmtBRL, PAY_LABELS } from "./constants";

function esc(v) {
  if (v === null || v === undefined) return "";
  return String(v).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}

const now = () => new Date().toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export async function exportPartnershipReport({ periodLabel, cfg, orders, sales, expenses, calc }) {
  let storeName = "Phone Lab";
  try { const r = await api.get("/settings"); storeName = r.data?.storeName || storeName; } catch {}

  const {
    receitaServicos, custoServicos, receitaPecas, custoPecas, despesasTotal,
    servicosNet, pecasNet, servicosA, servicosB, pecasA, pecasB, totalA, totalB, shareA, shareB,
  } = calc;

  const ordersRows = orders.map((o) => `
    <tr>
      <td>${esc(o.exitDate || o.entryDate || "—")}</td>
      <td>${esc(o.orderNumber || "OS")}</td>
      <td>${esc(o.clientName || "—")}</td>
      <td>${esc((o.services || []).join(", "))}</td>
      <td class="num">R$ ${fmtBRL((Number(o.total) || 0) - (Number(o.discount) || 0))}</td>
      <td class="num neg">R$ ${fmtBRL(Number(o.costValue) || 0)}</td>
    </tr>`).join("");

  const salesRows = sales.map((s) => `
    <tr>
      <td>${esc(s.date || "—")}</td>
      <td>${esc(s.piece || "—")}</td>
      <td>${esc(s.clientStore || "—")}</td>
      <td>${esc(PAY_LABELS[s.payMethod] || "—")}</td>
      <td class="num">R$ ${fmtBRL((Number(s.value) || 0) - (Number(s.discount) || 0))}</td>
      <td class="num neg">R$ ${fmtBRL(Number(s.costValue) || 0)}</td>
    </tr>`).join("");

  const html = `<html><head><meta charset="utf-8"/><title>Fechamento entre sócios — ${esc(periodLabel)}</title>
<style>
  *{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact}
  body{font-family:-apple-system,"Segoe UI","Helvetica Neue",Arial,sans-serif;color:#0f172a;margin:0;padding:24px 30px;background:#f8fafc;font-size:11pt}
  .rpt{max-width:900px;margin:0 auto;background:#fff;border:1px solid #e2e8f0;border-radius:8px;overflow:hidden}
  header{padding:22px 28px;background:linear-gradient(135deg,#6b21a8 0%,#9333ea 100%);color:#fff}
  header .brand{font-size:10pt;font-weight:600;opacity:.85;letter-spacing:.06em;text-transform:uppercase;margin-bottom:4px}
  header h1{margin:0;font-size:20pt;font-weight:800;letter-spacing:-0.02em}
  header .meta{margin-top:8px;font-size:10pt;opacity:.9;display:flex;gap:18px;flex-wrap:wrap}
  section{padding:20px 28px}
  section h2{font-size:12pt;text-transform:uppercase;letter-spacing:.05em;color:#1e293b;margin:0 0 12px;font-weight:700;padding-bottom:8px;border-bottom:2px solid #e2e8f0}
  .partners{display:grid;grid-template-columns:1fr 1fr;gap:16px}
  .partner{border:2px solid #e2e8f0;border-radius:10px;padding:16px}
  .partner.a{border-color:#c084fc;background:#faf5ff}
  .partner.b{border-color:#93c5fd;background:#eff6ff}
  .partner .name{font-size:10pt;font-weight:800;text-transform:uppercase;letter-spacing:.05em}
  .partner.a .name{color:#6b21a8}.partner.b .name{color:#1e40af}
  .partner .total{font-size:26pt;font-weight:800;margin:4px 0;font-variant-numeric:tabular-nums;letter-spacing:-0.02em}
  .partner.a .total{color:#581c87}.partner.b .total{color:#1e3a8a}
  .partner .lines{font-size:10pt;line-height:1.6}
  .partner .lines .v{font-weight:700;font-variant-numeric:tabular-nums;float:right}
  .calc{background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:14px 18px;font-size:10pt}
  .calc .row{display:flex;justify-content:space-between;padding:4px 0}
  .calc .row.total{border-top:2px solid #cbd5e1;margin-top:4px;padding-top:8px;font-weight:700}
  .calc .neg{color:#b91c1c}.calc .pos{color:#065f46}
  table{width:100%;border-collapse:collapse;margin-top:8px}
  thead th{background:#f1f5f9;text-align:left;padding:8px 10px;font-size:9pt;font-weight:700;color:#475569;text-transform:uppercase;letter-spacing:.04em;border-bottom:1px solid #cbd5e1}
  tbody td{padding:6px 10px;border-bottom:1px solid #f1f5f9;font-size:9.5pt}
  tbody tr:nth-child(even) td{background:#fafbfc}
  td.num{text-align:right;font-variant-numeric:tabular-nums;font-weight:600;white-space:nowrap;color:#1d4ed8}
  td.num.neg{color:#b91c1c}
  footer{padding:14px 28px;background:#f8fafc;border-top:1px solid #e2e8f0;font-size:9pt;color:#64748b;text-align:center}
  .signatures{display:grid;grid-template-columns:1fr 1fr;gap:40px;margin-top:60px}
  .sign{border-top:1px solid #94a3b8;padding-top:8px;text-align:center;font-size:10pt;color:#475569}
  .actions{max-width:900px;margin:0 auto 20px;display:flex;justify-content:flex-end;gap:8px}
  .btn{padding:9px 18px;border-radius:6px;font-weight:600;font-size:10.5pt;border:1px solid #cbd5e1;background:#fff;color:#334155;cursor:pointer}
  .btn-primary{background:#7e22ce;border-color:#7e22ce;color:#fff}
  @media print{body{padding:0;background:#fff}.actions{display:none}.rpt{border:0;border-radius:0}@page{size:A4;margin:12mm}}
</style></head><body>
  <div class="actions">
    <button class="btn" onclick="window.close()">Fechar</button>
    <button class="btn btn-primary" onclick="window.print()">🖨️ Imprimir / Salvar em PDF</button>
  </div>
  <div class="rpt">
    <header>
      <div class="brand">Fechamento entre sócios</div>
      <h1>${esc(storeName)}</h1>
      <div class="meta">
        <span><b>Período:</b> ${esc(periodLabel)}</span>
        <span><b>Emitido em:</b> ${now()}</span>
        <span><b>Regra:</b> Serviços ${shareA}% / ${shareB}% · Peças ${cfg.includePartsInSplit ? shareA + "/" + shareB + "%" : "100% " + esc(cfg.partnerAName)}</span>
      </div>
    </header>

    <section>
      <h2>Rateio final</h2>
      <div class="partners">
        <div class="partner a">
          <div class="name">${esc(cfg.partnerAName)}</div>
          <div class="total">R$ ${fmtBRL(totalA)}</div>
          <div class="lines">
            <div>Serviços (${shareA}%) <span class="v">R$ ${fmtBRL(servicosA)}</span></div>
            <div>Peças ${cfg.includePartsInSplit ? "(" + shareA + "%)" : "(100%)"} <span class="v">R$ ${fmtBRL(pecasA)}</span></div>
          </div>
        </div>
        <div class="partner b">
          <div class="name">${esc(cfg.partnerBName)}</div>
          <div class="total">R$ ${fmtBRL(totalB)}</div>
          <div class="lines">
            <div>Serviços (${shareB}%) <span class="v">R$ ${fmtBRL(servicosB)}</span></div>
            <div>Peças ${cfg.includePartsInSplit ? "(" + shareB + "%)" : "(0%)"} <span class="v">R$ ${fmtBRL(pecasB)}</span></div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <h2>Cálculo detalhado</h2>
      <div class="calc">
        <div class="row"><span>Receita bruta de serviços (OSs entregues)</span><b>R$ ${fmtBRL(receitaServicos)}</b></div>
        <div class="row"><span>(−) Custo de peças usadas nas OSs</span><b class="neg">R$ ${fmtBRL(custoServicos)}</b></div>
        ${cfg.splitExpenses ? `<div class="row"><span>(−) Despesas fixas do período</span><b class="neg">R$ ${fmtBRL(despesasTotal)}</b></div>` : ""}
        <div class="row total"><span>Serviços líquido para rateio</span><b class="pos">R$ ${fmtBRL(servicosNet)}</b></div>
        <div style="height:10px"></div>
        <div class="row"><span>Receita bruta de peças (vendas)</span><b>R$ ${fmtBRL(receitaPecas)}</b></div>
        <div class="row"><span>(−) Custo das peças vendidas</span><b class="neg">R$ ${fmtBRL(custoPecas)}</b></div>
        <div class="row total"><span>Peças líquido</span><b class="pos">R$ ${fmtBRL(pecasNet)}</b></div>
      </div>
    </section>

    <section>
      <h2>OSs do período (${orders.length})</h2>
      ${orders.length === 0 ? "<p style='color:#94a3b8;font-style:italic'>Nenhuma OS entregue no período.</p>" : `
      <table><thead><tr><th>Data</th><th>Nº OS</th><th>Cliente</th><th>Serviços</th><th style="text-align:right">Receita</th><th style="text-align:right">Custo</th></tr></thead>
      <tbody>${ordersRows}</tbody></table>`}
    </section>

    <section>
      <h2>Vendas de peças (${sales.length})</h2>
      ${sales.length === 0 ? "<p style='color:#94a3b8;font-style:italic'>Nenhuma venda de peça no período.</p>" : `
      <table><thead><tr><th>Data</th><th>Peça</th><th>Cliente/Loja</th><th>Pagamento</th><th style="text-align:right">Receita</th><th style="text-align:right">Custo</th></tr></thead>
      <tbody>${salesRows}</tbody></table>`}
    </section>

    <section>
      <div class="signatures">
        <div class="sign">${esc(cfg.partnerAName)}</div>
        <div class="sign">${esc(cfg.partnerBName)}</div>
      </div>
    </section>

    <footer>Documento gerado automaticamente pelo sistema — ${esc(storeName)} · ${now()}</footer>
  </div>
</body></html>`;

  const win = window.open("", "_blank", "width=1000,height=800");
  if (!win) return;
  win.document.open();
  win.document.write(html);
  win.document.close();
  win.focus();
}
